import {
  AppBar,
  Toolbar,
  // Typography,
  Divider,
  IconButton,
  Box,
  useTheme,
} from '@mui/material';
import { AddCircle } from '@mui/icons-material';
import Search from './modules/search';
import Account from './modules/account';
import { useNavigate } from 'react-router-dom';
import { LogoIcon } from '@/components/base/icons';

export default function Topbar() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <AppBar
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          boxShadow: theme.shadows[0],
        }}
        color="inherit"
        position="fixed"
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box display="flex" alignItems="center">
            <LogoIcon
              sx={(theme) => ({
                cursor: 'pointer',
                color: theme.palette.primary.main,
              })}
              fontSize="large"
              onClick={() => navigate('/home')}
            />
            <IconButton
              onClick={() => navigate('/shadow-upload')}
              size="small"
              sx={{ marginLeft: theme.spacing(2) }}
            >
              <AddCircle fontSize="small" />
            </IconButton>
          </Box>
          <Box display="flex" alignItems="center">
            <Search />
            <Account />
          </Box>
        </Toolbar>
        <Divider />
      </AppBar>
      {/* <Toolbar></Toolbar> */}
    </>
  );
}
